class DepartmentModel {
  constructor({
    departmentId = null,
    departmentName,
    companyId,
    referencedDepartmentId = null,
    createdAt = new Date(),
    updatedAt = new Date(),
  }) {
    this.departmentId = departmentId;
    this.departmentName = departmentName;
    this.companyId = companyId;
    this.referencedDepartmentId = referencedDepartmentId;
    this.createdAt = createdAt instanceof Date ? createdAt : new Date(createdAt);
    this.updatedAt = updatedAt instanceof Date ? updatedAt : new Date(updatedAt);

    // Perform validation on initialization
  }

  validate() {
    if (!this.departmentName) {
      throw new Error("Department Name is required.");
    }
    if (!this.companyId) {
      throw new Error("Company ID is required.");
    }
  }
}

export default DepartmentModel;
